const url = "https://api.fownd.care/api/v1"
// const url = "https://gmrkhsda8k.us-east-1.awsapprunner.com/api/v1"
// const url = "http://192.168.29.136:5000/api/v1"

export default url;